import { trimSearch } from '@xmatters/common/utils/searchUtil';
import { getUsersBySearchAction } from '@xmatters/redux/actions/listPage';
import { hydrateActiveUsers as hydrator } from '../groupList';

export const GET_USER_PERFORMANCE_DATA = 'GET_USER_PERFORMANCE_DATA';
export const GET_USER_PERFORMANCE_DATA_FAIL = `${GET_USER_PERFORMANCE_DATA}_FAIL`;
export const GET_USER_PERFORMANCE_DATA_START = `${GET_USER_PERFORMANCE_DATA}_START`;
export const GET_USER_PERFORMANCE_DATA_SUCCESS = `${GET_USER_PERFORMANCE_DATA}_SUCCESS`;
export const USER_PERFORMANCE_SEARCH_USERS = 'USER_PERFORMANCE_SEARCH_USERS';
export const USER_PERFORMANCE_SEARCH_USERS_START = `${USER_PERFORMANCE_SEARCH_USERS}_START`;
export const USER_PERFORMANCE_SEARCH_USERS_SUCCESS = `${USER_PERFORMANCE_SEARCH_USERS}_SUCCESS`;
export const USER_PERFORMANCE_SEARCH_USERS_FAIL = `${USER_PERFORMANCE_SEARCH_USERS}_FAIL`;
export const USER_PERFORMANCE_RESET_USERS_FILTERS =
  'USER_PERFORMANCE_RESET_USERS_FILTERS';
export const USER_PERFORMANCE_ACTIVE_USERS_FILTERS =
  'USER_PERFORMANCE_ACTIVE_USERS_FILTERS';
export const USER_PERFORMANCE_SEARCH_SITES = 'USER_PERFORMANCE_SEARCH_SITES';
export const USER_PERFORMANCE_SEARCH_SITES_START = `${USER_PERFORMANCE_SEARCH_SITES}_START`;
export const USER_PERFORMANCE_SEARCH_SITES_SUCCESS = `${USER_PERFORMANCE_SEARCH_SITES}_SUCCESS`;
export const USER_PERFORMANCE_SEARCH_SITES_FAIL = `${USER_PERFORMANCE_SEARCH_SITES}_FAIL`;
export const USER_PERFORMANCE_RESET_SITES_FILTERS =
  'USER_PERFORMANCE_RESET_SITES_FILTERS';
export const USER_PERFORMANCE_ACTIVE_SITES_FILTERS =
  'USER_PERFORMANCE_ACTIVE_SITES_FILTER';
export const USER_PERFORMANCE_HYDRATE_ACTIVE_USERS =
  'USER_PERFORMANCE_HYDRATE_ACTIVE_USERS';
export const USER_PERFORMANCE_HYDRATE_ACTIVE_USERS_START = `${USER_PERFORMANCE_HYDRATE_ACTIVE_USERS}_START`;
export const USER_PERFORMANCE_HYDRATE_ACTIVE_USERS_SUCCESS = `${USER_PERFORMANCE_HYDRATE_ACTIVE_USERS}_SUCCESS`;
export const USER_PERFORMANCE_HYDRATE_ACTIVE_USERS_FAIL = `${USER_PERFORMANCE_HYDRATE_ACTIVE_USERS}_FAIL`;
export const USER_PERFORMANCE_HYDRATE_ACTIVE_DYNAMIC_FILTERS =
  'USER_PERFORMANCE_HYDRATE_ACTIVE_DYNAMIC_FILTERS';
export const USER_PERFORMANCE_RESET_USER_DATA =
  'USER_PERFORMANCE_RESET_USER_DATA';

export const hydrateActiveDynamicFilters = payload => {
  return {
    type: USER_PERFORMANCE_HYDRATE_ACTIVE_DYNAMIC_FILTERS,
    payload,
  };
};

export const hydrateActiveUsers = activeUserIds => {
  const params = {};

  if (activeUserIds) {
    params.id = activeUserIds;
  }

  return {
    ...hydrator(activeUserIds),
    type: USER_PERFORMANCE_HYDRATE_ACTIVE_USERS,
  };
};

export const getUserPerformanceData = ({
  from,
  to,
  supervisedByMe,
  sortBy,
  sortOrder,
  recipients,
  priority,
  sites,
  workflow,
  limit,
  offset,
  schedule = false,
  jobId = null,
}) => {
  return {
    type: GET_USER_PERFORMANCE_DATA,
    meta: {
      xmApi: true,
      method: 'get',
      uri: '/webapi/abe/1/performance/users',
      params: {
        from,
        limit,
        offset,
        supervisedByMe,
        sortBy,
        sortOrder,
        recipients,
        priority,
        sites,
        workflow,
        to,
        schedule,
        ...(jobId && { jobId }),
      },
    },
  };
};

export const getUsersBySearch = getUsersBySearchAction(
  USER_PERFORMANCE_SEARCH_USERS,
);

export const setActiveUserFilters = users => ({
  type: USER_PERFORMANCE_ACTIVE_USERS_FILTERS,
  payload: users,
});

export const resetUserFilters = users => ({
  type: USER_PERFORMANCE_RESET_USERS_FILTERS,
  payload: users,
});

export const resetSitesFilters = sites => ({
  type: USER_PERFORMANCE_RESET_SITES_FILTERS,
  payload: sites,
});

export const setActiveSitesFilters = sites => ({
  type: USER_PERFORMANCE_ACTIVE_SITES_FILTERS,
  payload: sites,
});

export const getSitesBySearch = ({ search }) => {
  const params = {};
  params.limit = 100;

  const trimmedSearchText = trimSearch(search);
  if (trimmedSearchText.length >= 2) {
    params.search = trimmedSearchText;
    params.operand = 'AND';
    params.fields = ['NAME'];
  }

  return {
    type: USER_PERFORMANCE_SEARCH_SITES,
    meta: {
      xmApi: true,
      method: 'get',
      uri: `/webapi/xm/1/sites`,
      params,
    },
  };
};

export const setActiveDynamicSitesFilters = sites => {
  return {
    type: USER_PERFORMANCE_ACTIVE_SITES_FILTERS,
    payload: sites,
  };
};

export const resetDynamicSitesFilters = sites => {
  return {
    type: USER_PERFORMANCE_RESET_SITES_FILTERS,
    payload: sites,
  };
};

export const resetUserData = () => {
  return {
    type: USER_PERFORMANCE_RESET_USER_DATA,
  };
};
